<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">

#app,html,body{
  width: 100%;
  height: 100%;
  min-width: 1366px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue